import { put } from 'redux-saga/effects';
import { setBettingOdds } from '../actions';

/**
 * @typedef {object} UpdateBettingOddsAction
 * @property {string} type
 * @property {object} payload
 * @property {boolean} payload.isActive
 */

/**
 * @param {UpdateBettingOddsAction} action - The Redux action.
 */
export function* updateBettingOdds(action) {
    yield put(setBettingOdds(action.payload));
}
